import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/core"
import {
  weddingPartyMember,
  weddingPartyContent,
  contentLeft,
  weddingPartyMemberImage,
} from "../weddingPartyMember"

const imageWrapper = css`
  @media screen and (min-width: 680px) {
    position: absolute;
    top: -60px;
    right: -60px;
  }

  @media screen and (min-width: 860px) {
    width: 487px;
  }
`

const Adnana = props => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "adnana.png" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 487) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div css={weddingPartyMember}>
      <div css={[weddingPartyMemberImage, imageWrapper]}>
        <Img
          fluid={data.file.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
          {...props}
        />
      </div>
      <div css={[weddingPartyContent, contentLeft]}>
        <div>
          <h2>Adnana Mustafić</h2>
          <p>
            Arijana&rsquo;s older sister, who would point out her bullies during
            recess so that Arijana could take them to the girls bathroom and
            punch them in Adnana&rsquo;s honor.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Adnana
